import getSavedItemCount from "./getSavedItemCount";
import getError from "./getError";
import getProductsString from "./getProductsString";
import getDtcAndAfsLabelsCountString from "./getDtcAndAfsLabelsCountString";
import getEvents from "./getEvents";
import { shouldShowNotifyMe } from "../../../../backInStock/selectors";

export const receiveItems = (state, { payload }) => {
  const {
    trackPage: { savedItemCount },
    itemsType
  } = state;
  const isFirstPageLoad = savedItemCount === undefined;

  if (!isFirstPageLoad) {
    return state;
  }

  const {
    savedItems: { savedItemProducts, itemCount, itemCountMismatch }
  } = payload;

  return {
    ...state,
    buttonShownForVariants: savedItemProducts
      .filter(shouldShowNotifyMe)
      .map(({ variantId }) => variantId),
    trackPage: {
      ...state.trackPage,
      savedItemCount: getSavedItemCount(itemCount),
      productsString: getProductsString(savedItemProducts),
      events: [
        ...(state.trackPage.events ?? []),
        ...getEvents(savedItemProducts)
      ],
      dtcAndAfsCountString: getDtcAndAfsLabelsCountString(savedItemProducts),
      ...getError({ itemsType, itemCountMismatch, itemCount })
    }
  };
};
